const BREAKPOINTS = {
    MD: 768  // Match Bootstrap $grid-breakpoints
};

/**
 * Updates carousel control visibility based on product count and viewport
 * @param {jQuery} $carousel - The carousel element
 */
function updateCarouselControlVisibility($carousel) {
    const $carouselItems = $carousel.find('.carousel-item');
    const displayProducts = $carouselItems.length;
    var $liTemplate = $carousel.find('.hidden-indicators-template li');

    if (displayProducts === 0) {
        $carousel.addClass('hide-indicators');
        return;
    }

    const displayControls = {
        xs: $carousel.data('xs') || 2,
        md: $carousel.data('md') || 4
    };

    const isDesktop = window.matchMedia(`(min-width: ${BREAKPOINTS.MD}px)`).matches;
    const isMobile = window.matchMedia(`(max-width: ${BREAKPOINTS.MD - 0.1}px)`).matches;
    
    const shouldShowControls = 
        (isDesktop && displayProducts > displayControls.md) ||
        (isMobile && displayProducts > displayControls.xs);

    const $indicators = $carousel.find('.pd-carousel-indicators');
    const maxTiles = isDesktop ? displayControls.md : displayControls.xs;
    $indicators.empty();
    $carouselItems.each(function (index) {
        var $newIndicator = $liTemplate.clone();
        // Append a new indicator for each set of maxTiles
        if (index % maxTiles === 0) {
            if (index === 0) {
                $indicators.append($newIndicator);
            } else {
                $newIndicator.removeClass('active');
                $indicators.append($newIndicator);
            }
            $indicators.find('li').last().attr('data-slide-to', index);
            $indicators.find('li').last().attr('data-position', index);
        }
    });

    if (shouldShowControls) {
        $carousel.removeClass('hide-indicators');
    } else {
        $carousel.addClass('hide-indicators');
    }
}

module.exports = {
    updateCarouselControlVisibility: updateCarouselControlVisibility
};